<app-widget [hideIcon]="true">
  <!-- The skeletons below are decorative: the Views page announces its loading (#6305). -->
  @if (isViewReady()) { @switch (currentView()) { @case (ViewEnum.PAST) {
  <app-balance-chart></app-balance-chart>
  } @case (ViewEnum.TODAY) {
  <app-bubble-chart
    [dataSet]="computedData().dataSet"
    [showBalance]="userStoreService.showBalance()"
  ></app-bubble-chart>
  } @case (ViewEnum.FUTURE) {
  <app-scenario-chart></app-scenario-chart>
  } } } @else if (showBackgroundSkeleton()) { @if (currentView() === ViewEnum.TODAY) {
  <!-- Bubble chart skeleton -->
  <div class="tw-relative tw-w-full tw-h-64 tw-overflow-hidden" aria-hidden="true">
    <div
      class="tw-absolute tw-rounded-full tw-bg-dt-slate-8/40 tw-animate-pulse"
      style="width: 140px; height: 140px; left: 50%; top: 50%; transform: translate(-50%, -50%)"
    ></div>
    <div
      class="tw-absolute tw-rounded-full tw-bg-dt-slate-8/40 tw-animate-pulse"
      style="width: 90px; height: 90px; left: 22%; top: 18%; animation-delay: 150ms"
    ></div>
    <div
      class="tw-absolute tw-rounded-full tw-bg-dt-slate-8/40 tw-animate-pulse"
      style="width: 80px; height: 80px; left: 65%; top: 20%; animation-delay: 100ms"
    ></div>
    <div
      class="tw-absolute tw-rounded-full tw-bg-dt-slate-8/40 tw-animate-pulse"
      style="width: 60px; height: 60px; left: 30%; top: 65%; animation-delay: 200ms"
    ></div>
    <div
      class="tw-absolute tw-rounded-full tw-bg-dt-slate-8/40 tw-animate-pulse"
      style="width: 55px; height: 55px; left: 68%; top: 62%; animation-delay: 250ms"
    ></div>
  </div>
  } @else {
  <!-- Bar/line chart skeleton for Past and Future -->
  <div class="tw-w-full tw-h-64 tw-flex tw-items-end tw-gap-2 tw-px-4 tw-pb-4" aria-hidden="true">
    @for (h of [55, 75, 45, 90, 65, 80, 50, 70, 40, 85]; track $index) {
    <div
      class="tw-flex-1 tw-rounded-t tw-bg-dt-slate-8/40 tw-animate-pulse"
      [style.height.%]="h"
      [style.animation-delay]="($index * 50) + 'ms'"
    ></div>
    }
  </div>
  } }
</app-widget>
